/**
 * @vuepress
 * ---
 * title: followupTransformer
 */

import Transformer from '@/transformers/transformer'
import { attachMissingCurrentTime } from '@/utils/moment'
import { parentPrefixTransformer } from '@/transformers/utils'
import { minimalSinister, minimalAffected, FollowUpHistoryTransformer } from '@/transformers/sinister'
import { objectToForm, assetURL } from '@/utils'

/**
 * @class followupTransformer
 * @author José Luis Ruiz
 */

class followupTransformer extends Transformer {
  static fetch({
    id,
    affected,
    who_reports: whoReports,
    who_reports_name: whoReportsName,
    who_requests: whoRequests,
    request_date: requestDate,
    reporting_channel: reportingChannel,
    status,
    response,
    response_file: responseFile,
    promise_date: promiseDate,
    closure_date: closureDate,
    observations,
    add_date: addDate,
    who_responses: whoResponses,
    response_date: responseDate,
    missing_attention_first_encounter: missingAttentionFirstEncounter,
    settlement_date: settlementDate,
    user_follow_up: userFollowUp,
    folio,
    sinister,
    kind,
    history,
    last_escalation_level: lastEscalationLevel
  }) {
    return {
      id,
      whoReportsName,
      whoReports,
      whoRequests,
      requestDate,
      reportingChannel,
      status,
      statusName: status.name,
      statusSlug: status.slug,
      response,
      responseFile: responseFile ? assetURL(responseFile) : null,
      responseDate,
      promiseDate,
      closureDate,
      observations,
      addDate,
      whoResponses,
      folio,
      missingAttentionFirstEncounter,
      kind,
      userFollowUp,
      history: FollowUpHistoryTransformer.fetchCollection(history),
      // userFollowUpName: userFullName(userFollowUp),
      // userFollowUpId: userFollowUp.id,
      settlementDate,
      lastEscalationLevel,
      ...parentPrefixTransformer('affected', affected ? minimalAffected.fetch(affected) : {}),
      ...parentPrefixTransformer('sinister', sinister ? minimalSinister.fetch(sinister) : {})
    }
  }
  static send({
    casualty,
    requestDate,
    whoReports,
    reportingChannel,
    observations,
    whoReportsName,
    missingAttentionFirstEncounter,
    kind

  }) {
    return {
      'affected': casualty,
      'who_reports_name': whoReportsName,
      'request_date': attachMissingCurrentTime(requestDate),
      'who_reports': whoReports,
      'reporting_channel': reportingChannel,
      observations,
      missing_attention_first_encounter: !!missingAttentionFirstEncounter,
      kind
    }
  }
  static response({
    promiseDate,
    response,
    responseFile
  }) {
    const payload = {
      response,
      promise_date: attachMissingCurrentTime(promiseDate),
      response_file: responseFile instanceof File ? responseFile : typeof responseFile === 'string' ? 'file' : null
    }
    return objectToForm(payload)
  }
  static update() {}
}
export default followupTransformer
